import { render, staticRenderFns } from "./StaffControl.vue?vue&type=template&id=f8573fe0&scoped=true&"
import script from "./StaffControl.vue?vue&type=script&lang=js&"
export * from "./StaffControl.vue?vue&type=script&lang=js&"
import style0 from "./StaffControl.vue?vue&type=style&index=0&id=f8573fe0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8573fe0",
  null
  
)

export default component.exports